import * as api from '../api.js';

import { getPhoneNumber, INITIAL_STATE, STATE_TITLE_MAP } from '#constants';

export const getCurrentLocation = async (set, get) => {
  const { state_prov, city, country_code2 } = await api.getCurrentLocation();
  let physicalCountry = 'US';
  if (['NZ', 'AU', 'CA'].indexOf(country_code2) > -1) {
    physicalCountry = country_code2;
  }

  const location = {
    state: state_prov,
    city,
    country: physicalCountry,
    updated: true,
  };
  set({
    location,
  });
  return location;
};

export const getStateRecs = async (set, get, { stateCode }) => {
  const { success, failure } = await api.getStateRecs({
    stateCode,
  });
  if (failure) {
    return;
  }
  const { stateRecs } = success;
  // updating the user
  set({ stateRecs });
};

export const resetStore = async (set, get) => {
  set(
    {
      trackerInput: INITIAL_STATE.trackerInput,
      savedFlexiDays: null,
      searchInput: '',
      outing: {},
      sessionInfo: INITIAL_STATE.sessionInfo,
      user: {},
      news: {
        show: false,
        text: '',
      },
    },
    false,
    { type: 'resetStore' }
  );
};

export const syncTawkVisitor = (set, get) => {
  const { user, tawk } = get();
  if (!user) return;
  if (!tawk?.current?.setAttributes) return;
  const hasEmail = !!user.email;
  const phone = getPhoneNumber(user) ?? '';
  const hasPhone = !!phone;
  if (!hasEmail && !hasPhone) return;

  const fullName = [user.firstName, user.lastName].filter(Boolean).join(' ') || user.name || '';
  const name = fullName || phone;
  const attrs = { name };
  if (hasEmail) attrs.email = user.email;
  try {
    tawk.current.setAttributes(attrs, () => {});
  } catch (_) {}
};
